<template>
  <div>
    <main>
      <section class="main-title">
        <h1>アセットマスタ作成</h1>
      </section>
      <template>
        <Form
          :onFormPost="onNewFormPost"
          :validation_errors="validation_errors"
          :isNoFade="isNoFade"
        />
      </template>
    </main>
  </div>
</template>

<script>

  // フォームのコンポーネント読み込み
  import Form from './Form';

  export default {
    components: {
      Form
    },

    metaInfo: {
      title: 'アセットマスタ作成',
    },

    data() {
      return {
        was_valid: false,
        validation_errors: {},
        previous_route: null,
      }
    },

    props: { isNoFade: Boolean },

    // インスタンス生成後、リアクティブデータ初期化後
    created() {
      this.init();
    },

    // メソッド定義
    methods: {
      // 初期化
      init() {
      },

      // 保存ボタン押下
      onNewFormPost(form) {
        this.$loading.load(
          this.$auth.api.post(
            'admin/asset_masters', form
          ).then(res => {
            if (!!this.previous_route && this.previous_route.name === 'AdminAssetMasterIndex') {
              this.$router.push({path: this.previous_route.fullPath, query: {toast_type: 'created'}});
            } else {
              this.$router.push({name: 'AdminAssetMasterIndex', query: {toast_type: 'created'}});
            }
          }).catch(err => {
            // バリデーションエラー
            if (err.response.status == 422) {
              this.validation_errors = err.response.data.errors;
              // エラー時ページトップにスクロール
              window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
            } else if (err.response.status == 500) {
              this.$errorHandlers.initial(err);
            } else {
              this.$errorHandlers.ajax(err);
            }
          })
        )
        // 確認ボタン押下の確認、falseの時はis-invalidが付与されない
        this.was_valid = true;
      },
    },
    // コンポーネントを描画するルートが確立する前に呼ばれる
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.previous_route = from;
      });
    },
  }

</script>
